import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Controlla lo stato di autenticazione all'inizializzazione
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    const token = localStorage.getItem('token');
    const userInfoStr = localStorage.getItem('user');

    try {
      if (token && userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        setUser(userInfo);
        setIsAuthenticated(true);
      } else {
        logout();
      }
    } catch (error) {
      logout();
    } finally {
      setIsLoading(false);
    }
  };

  const login = (userData, accessToken) => {
    // Salva le informazioni utente e il token
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', accessToken);
    
    setUser(userData);
    setIsAuthenticated(true);
  };

  const logout = () => {
    // Rimuove le informazioni utente e il token
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    
    setUser(null);
    setIsAuthenticated(false);
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  };

  const hasRole = (allowedRoles) => {
    if (!user) return false;
    return allowedRoles.includes(user.role);
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    hasRole
  };
};

// Esempio di utilizzo in un componente
export const ProfileMenu = () => {
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <div className="user-profile">
      <div className="flex items-center">
        <span className="mr-2">{user.username}</span>
        <span className="text-sm text-gray-500">({user.role})</span>
        <button 
          onClick={logout}
          className="ml-2 text-red-500 hover:text-red-700"
        >
          Logout
        </button>
      </div>
    </div>
  );
};